import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DataHolderVo } from 'src/app/models/DataHolderVo';
import { Feeds } from 'src/app/models/feeds';
import { JobOpeningsVo } from 'src/app/models/jobOpenings';
import { TechQuestionVo } from 'src/app/models/questDeatilVo';

@Component({
  selector: 'app-dashboard-view-one',
  templateUrl: './dashboard-view-one.component.html',
  styleUrls: ['./dashboard-view-one.component.scss']
})
export class DashboardViewOneComponent implements OnInit {

  constructor(private http: HttpClient,private route:Router) { }

  feeds:Feeds[] = [];
  jobOpenings:JobOpeningsVo[] = [];
  questions:TechQuestionVo[] = [];
  imageUrl: any = "https://codingislove.com/wp-content/uploads/2015/12/codinglovenew.png";

  @Output() selectedCard = new EventEmitter<string>(); 

  ngOnInit(): void {
    this.loadData();
    // this.http.get('http://api.linkpreview.net/?key=accd5245417245de6140169b9d5ff688&q=https://codingislove.com').subscribe((data: any)=>{
    //   this.imageUrl = data.image;
    // })
  }

   detailView(type:any,id:string){
         
         let wholeData = new DataHolderVo();
         wholeData.feeds = this.feeds;
         wholeData.jobOpenings = this.jobOpenings;
         wholeData.questions = this.questions;
         
         let val = type+":"+id;
         this.route.navigateByUrl("home/"+val,{ state: wholeData })
        //  this.selectedCard.emit(val);
   }

  loadData(){
    this.getFeedsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;




       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);


       this.feeds = listData;
      });

      this.getJobOpeningsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.jobOpenings = listData;
      
      });

      this.gettechQuestionsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.questions = listData;
      
      });
  }

  // emitSelectedCard(){
  //       this.selectedCard.emi
  // }

  getFeedsListCall() {
    return this.http.get("https://3898i2a7t4.execute-api.us-west-1.amazonaws.com/default/getFeedList");
  }

  gettechQuestionsListCall() {
    return this.http.get("https://tdnuf7xcgjqaeqfpohjmy3zvei0uhfoy.lambda-url.us-west-1.on.aws/");
  }

  getJobOpeningsListCall() {
    return this.http.get("https://gizcv5lgqmwykti2kbx6py76wq0lildi.lambda-url.us-west-1.on.aws/");
  }

  getPreviewData() {
    this.http.get('http://api.linkpreview.net/?key=7f28829d7d2cfdaf7ea5f1fe0249dd6b&q=https://codingislove.com').subscribe(data=>{
      return data;
    })
  }

  async getPreview(): Promise<any> {
    let res:any = await this.getPreviewData();
    return res.image;
  }

  isMetadataAvailable(obj: any):boolean {
    if(obj && obj.linkMetaData && obj.linkMetaData.image) {
      return true;
    }
    return false;
  }

  isMetadataAvailableWithoutImage(obj: any):boolean {
    if(obj && obj.linkMetaData) {
      return true;
    }
    return false;
  }

}
